import { Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { theme } from "src/assets/theme";
import { usePatient } from "src/context/PatientProvider";
import { useProduct } from "src/context/ProductProvider";
import { useIsMobile } from "src/hooks/useIsMobile";

const Header = () => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const page = "payment-information";
  const firstName = usePatient((patient) => patient.profile.first_name);
  const language = usePatient((patient) => patient.profile.language);
  const productSlug = useProduct((p) => p.slug);

  const header = useMemo(() => {
    const string = t(`${page}.title`, { first_name: firstName });
    const words = string.split(" ");
    const last = words.pop() || "";

    if (["ec"].includes(productSlug)) {
      const title2 = t(`${page}.title-2`, "{{first_name}}'s treatment plan", {
        first_name: firstName,
      });

      return (
        <Typography variant={isMobile ? "h5" : "h4"} fontWeight={700}>
          {title2}
        </Typography>
      );
    }

    if (language === "en") {
      return (
        <Typography variant={isMobile ? "h5" : "h4"} fontWeight={700}>
          {words.join(" ")}{" "}
          <span
            style={{ fontStyle: "italic", color: theme.palette.primary.main }}
          >
            {last}
          </span>
        </Typography>
      );
    } else {
      const highlightedWord = "aprobaron";
      const [before, match, after] = string.split(
        new RegExp(`(${highlightedWord})`, "i")
      );

      return (
        <Typography variant={isMobile ? "h5" : "h4"} fontWeight={700}>
          {before}
          <span
            style={{ fontStyle: "italic", color: theme.palette.primary.main }}
          >
            {match}
          </span>
          {after}
        </Typography>
      );
    }
  }, [firstName, isMobile, language, productSlug, t]);

  return <>{header}</>;
};

export default Header;
